import React from "react";
import ReactDOM from "react-dom";
import "./Index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from 'react-router-dom'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
} from "react-router-dom";
import "./Index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Survey from "./Survey";
import EnhancedCreateaSurvey from "./CreateaSurvey";
import { Container, Row, Col } from 'react-grid-system';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Input,
  Grid,
  FormHelperText,
  Button
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { Hidden } from '@material-ui/core';
import DialogActions from "@material-ui/core/DialogActions";
import { GREY, RED, LIGHTBLUE, LIGHTGREY } from "../../utils/color_utils";
import SendIcon from "@material-ui/icons/Send";
import { showToast } from "../../store/actions/toastAction";
import { createSurvey } from "../../store/actions/SurveyActions";
import { updateSurvey } from "../../store/actions/surveyUpdate";
import { surveyStats } from "../../store/actions/surveyStatsAction";
import { simpleAction } from "../../store/actions/simpleAction";
import { surveyTestsDisplay } from "../../store/actions/surveyTestsDisplayAction";
import firebase from "../../store/firebase";
import { connect } from "react-redux";
import {
  SURVEY_LIST,
  UPDATE_SURVEY,
  SURVEY_STATS_LIST,
  SIMPLE_VALUES,
  SURVEY_TESTS_LIST
} from "../../store/actions/types";
import { array } from "prop-types";
import survey from './img/surveypic.jpg';
import './sidebar.css'; 
import { blue } from "@material-ui/core/colors";
import { useRouteMatch } from "../../common/useRouteMatch";

const sendBtn = {
  backgroundColor: LIGHTBLUE,
  color: "#fff"
};
const sendBtn2 = {
  backgroundColor: RED,
  color: "#fff"
};
const table = {
    color: "#515A5A",
    fontSize: 14,
    border: "1px solid #CAC9C8",
    backgroundColor: '#F2F3F4',
    padding: 1,
    borderRadius: 7
}
const tableh = {
  color: "#515A5A",
  fontSize: 14,
  border: "1px solid #707B7C",
  backgroundColor: '#F2F3F4',
  padding: 10,
  borderRadius: 15
}
const tableM = {
  color: "#515A5A",
  fontSize: 18,
  border: "1px solid #707B7C",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 15
}

const styles = {
  mlist: {
    width: 250,
  },
  survs: {
    width: 1500,
  },
  row2: {
  },
  col1: {
    backgroundColor: 'yellow',
  },
  col2: {
    backgroundColor: 'brown',
  },
  col: {
    padding: '1rem',
    backgroundColor: '#33b5e5',
    border: '2px solid #fff',
    color: '#fff',
    textAlign: 'center'
    }
};

class Surveys extends React.Component {
  constructor (props) {
     super(props);
  }

  state = {
    surveysLoaded: this.props.update_Survey,
    showPic: true,
    groupname: "",
    groupid: "",
    defaultgroup: "Select Group",
    gr: ""
  }

  componentDidMount() {
    

    // Check if userdata exists before accessing it
    if (!this.props.userdata || !this.props.userdata.userID) {
      
      return;
    }

    

    var database = firebase.database;
    database
      .ref("company_user_groups/" + this.props.userdata.userID)
      .once("value")
      .then(snapshot => {
        const groupsArr = [];

        snapshot.forEach(childSnapshot => {
          groupsArr.push({
            id: childSnapshot.key,
            group_id: childSnapshot.val().group_id,
            group_name: childSnapshot.val().group_name
          });
        });
        this.setState({ gr: groupsArr });
      });
  }

  functionTwo = (var1, callback) => {
    callback(var1);
       
   }

    objsize = (Myobj) => {
      var osize = 0, key;
      for (key in Myobj) {
          if (Myobj.hasOwnProperty(key)) osize++;
      }
      return osize;
    };

    getKeys(object) {
      function iter(o, p) {
          if (Array.isArray(o)) { return; }
          if (o && typeof o === 'object') {
              var keys = Object.keys(o);
              if (keys.length) {
                  keys.forEach(function (k) { iter(o[k], p.concat(k)); });
                  return;
              }
          }
          result.push(p.join('.'));
      }
      var result = [];
      iter(object, []);
      return result;
  }

  hidePic = (cond) => {
    
    this.setState({
      showPic: cond
    })
  }

  getS = (surid, groupid) => {
    
    
    
    var body = {
      type: SIMPLE_VALUES,
      surveyid: surid,
      groupid: groupid
    }
    this.props.getSurveyStage(body);
  }

  render(){
    const { update_Survey, surveyStats, survey_stats_list, simpleAction, surveyTestsDisplay } = this.props

    // Check if user is logged in
    if (!this.props.userdata) {
      return (
        <div style={{padding: '20px', textAlign: 'center'}}>
          <h2>Please log in to access the Points & Surveys section</h2>
          <p>You need to be logged in to create and manage surveys.</p>
        </div>
      );
    }

    
    
    

    return (
    <Router>
      <div className="noPrintMe">

      <Container>
        <Row style={styles.row}>
          <Col style={styles.mlist}>
            <h3>Tests and Surveys</h3>
            <Row>
              <b>
              <OldSchoolMenuLink
                activeOnlyWhenExact={true}
                to="createaSurvey"
                label="Make survey"
              />
                {update_Survey && Object.keys(update_Survey).map((QandA, id) => {
                  return (
                    <OldSchoolMenuLink
                      key={update_Survey[QandA].surveyid}
                      to={update_Survey[QandA].surveyid}
                      label={update_Survey[QandA].title}
                    />
                    );
                  }) 
                }
              </b>
            </Row>
          </Col>

          <Col style={styles.survs}>
            <Switch>
              <Route exact path="/createaSurvey">
                <EnhancedCreateaSurvey 
                  letgoPic={this.hidePic} 
                  key={this.props} 
                  props={this.props} 
                  userdata={this.props.userdata} 
                  title="Test" 
                  content="" 
                  thoughtID="test-id" 
                  createSurvey={this.props.createSurvey}
                  addMorePoints={this.props.addMorePoints}
                  getSurveyStage={this.props.getSurveyStage}
                  resetMakeTest={this.props.resetMakeTest}
                />
              </Route>

              {/* SURVEY STATS LINKS */}
              {update_Survey && Object.keys(update_Survey).map((QandA, id) => {
                const magicpath = "/x"+update_Survey[QandA].surveyid;
                

                return (
                  <Route exact path={magicpath} key={`stats-${update_Survey[QandA].surveyid}`}>
                   <SurveyAllStats
                      key={update_Survey[QandA].surveyid}
                      surveyid={update_Survey[QandA].surveyid} 
                      surveyType={update_Survey[QandA].type}
                      letgoPic={this.hidePic} 
                      surveyStats={surveyStats} 
                      simpleAction={simpleAction}
                      surveyTestsDisplay={surveyTestsDisplay}
                      survey_stats_list={survey_stats_list} 
                      survey_tests_list={this.props.survey_tests_list}
                      companyID={this.props.userdata ? this.props.userdata.companyID : ''} 
                      groupidx={this.state.groupname}
                      groupid={this.state.groupid}
                   />  
                   </Route>            
                    );
                  }) 
                }                                                                                                          
            {/* SURVEY LINKS */}
            { update_Survey && Object.keys(update_Survey).map((QandA, id) => {
             const magicpath = "/"+update_Survey[QandA].surveyid;

              return (
                <Route exact path={magicpath} key={`survey-${update_Survey[QandA].surveyid}`}>
                  <div>
                    <h2>{update_Survey[QandA].title}</h2>
                    <Survey 
                      letgoPic={this.hidePic} 
                      personid={this.props.userdata ? this.props.userdata.userID : ''} 
                      key={update_Survey[QandA].surveyid} 
                      companyID={this.props.userdata ? this.props.userdata.companyID : ''} 
                      surveyid={update_Survey[QandA].surveyid} 
                      typeofSurvey={update_Survey[QandA].type} 
                      size={update_Survey[QandA].size}
                      sections={update_Survey[QandA].sections || []}
                    />
                  </div>
                </Route>                    
                  );
                }) 
              }                                          
            </Switch>
          </Col>
         { this.state.showPic===true? <div className="howpic"><Col><div align="left"><img width="700px" height={500} alt="" src={survey} /></div></Col></div> 
          :null
         } 
        </Row>
      </Container>
      </div>
    </Router>
  );
 }
}

function OldSchoolMenuLink({ label, to, activeOnlyWhenExact }) {
  var tutu="/"+to;
  let match = useRouteMatch({
    path: tutu,
    exact: activeOnlyWhenExact
  });

  return (
    <div className={match ? "active" : ""}>
      {match && ">> "}
      <Link to={tutu}>{label}</Link>
    </div>
  );
}

class SurveyAllStats extends React.Component {
  constructor (props) {
     super(props);
  }

  state = {
    surveysLoaded: this.props.surveyStats,
    showPic: true
  }

  trimStripe(strIn){
    return strIn.slice(0, 20) + (strIn.length > 20 ? "..." : "");
  }

  componentDidMount() {

  }

    getS = () => {
      
      
      
      
      
      var body = {
        type: SURVEY_STATS_LIST,
        surveyid: this.props.surveyid,
        companyID: this.props.companyID,
        groupid: this.props.groupid
      }
      this.props.surveyStats(body);

      var body2 = {
        type: SURVEY_TESTS_LIST,
        surveyid: this.props.surveyid,
        companyID: this.props.companyID,
        groupid: this.props.groupid
      }
      this.props.surveyTestsDisplay(body2);
    }

   truncate(str){
     if (str.length <= 10) {
        return str;
     }
     return str.slice(0, 10) + '...';
   }

   objsize = (Myobj) => {
     var osize = 0, key;
     for (key in Myobj) {
         if (Myobj.hasOwnProperty(key)) osize++;
     }
     return osize;
   };

   componentWillReceiveProps(nextProps) {
     if (nextProps.surveyStats !== this.props.surveyStats) {
       this.setState({ surveysLoaded: nextProps.surveyStats });
     }
   }

  render(){
    

    const getPersentageScore = (score, qlen) => {
      var average = (score / qlen) * 100
      return average.toFixed(1) + '%'
    }

    const { survey_stats_list } = this.props;
    const { survey_tests_list } = this.props;

    return (
      <div className="bod">
        <h2>Survey and Test Statistics</h2>
        <Row>
          <Col sm={6}><Button variant="contained" onClick={this.getS} style={sendBtn}>GET TEST STATS</Button></Col>
        </Row>
        <br/>
        <Row>
          <Col sm={6}>
            <table style={tableM}>
              <thead>
                <tr>
                  <th style={tableh}>Person name</th>
                  <th style={tableh}>Score</th>
                  <th style={tableh}>Qlen</th>
                  <th style={tableh}>% Score</th>
                  <th style={tableh}>Date</th>
                </tr>
              </thead>
              <tbody>
                {survey_tests_list && Object.keys(survey_tests_list).map((x, id) => {
                  return (
                    <tr key={id}>
                      <td style={table}>{this.truncate(survey_tests_list[x].firstName + ' ' + survey_tests_list[x].lastName)}</td>
                      <td style={table}>{survey_tests_list[x].score}</td>
                      <td style={table}>{survey_tests_list[x].qlen}</td>
                      <td style={table}>{getPersentageScore(survey_tests_list[x].score, survey_tests_list[x].qlen)}</td>
                      <td style={table}>{this.trimStripe(survey_tests_list[x].stringDateOfTest)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userdata: state.auth.userdata,
  update_Survey: state.update_Survey,
  survey_stats_list: state.survey_stats_list,
  survey_tests_list: state.survey_tests_list,
  simpleValues: state.simpleValues
});

export default connect(
  mapStateToProps,
  { updateSurvey, showToast, createSurvey, surveyStats, simpleAction, surveyTestsDisplay }
)(Surveys); 